module.exports = __webpack_public_path__ + "static/media/maestro.bc7724f8.svg";